export const secondaryDrawercollapse = () => {
  return {
    type: 'drawerCollapse',
  };
};

export const activeSecondaryDrawer = (data: any) => {
  return {
    type: 'HandleActiveSecondaryDrawer',
    data,
  };
};
export const themeLayout = (data: any) => {
  return {
    type: 'HandleThemeLayout',
    data,
  };
};
export const deviceDiscovery = (data: any) => {
  return {
    type: 'HandleDeviceDiscovery',
    data,
  };
};
export const networkDiscovery = (data: any) => {
  return {
    type: 'HandleNetworkDiscovery',
    data,
  };
};

export const setNetworkSync = (networkId: string, isSync: boolean) => {
  return {
    type: 'SetNetworkSync',
    payload: {
      networkId,
      isSync,
    },
  };
};

export const logout = () => {
  return {
    // Clear Redux state
    type: 'RESET_APP',
  };
};

export const setMenuData = (data: any) => {
  return {
    type: 'Menu_SubMenu',
    MenuWiseData: data,
  };
};
export const setLoggedinData = (data: any) => {
  return {
    type: 'LoggedinUser',
    LoggedinUserData: data,
  };
};
export const SetSystemConfiguration = (data: any) => {
  return {
    type: 'System_Configuration',
    SystemConfig: data,
  };
};

export const setDateTimeData = (data: any) => {
  return {
    type: 'Date_Time',
    DateTime: data,
  };
};
export const setQuickSetupRes = (data: any) => {
  return {
    type: 'QuickSetupDataRes',
    QuickSetupData: data,
  };
};
export const mobileDrawerToggle = () => ({
  type: 'MOBILE_DRAWER_TOGGLE',
});

export const mobileDrawerClose = () => ({
  type: 'MOBILE_DRAWER_CLOSE',
});
